import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AnalyticsService} from '../../../analytics/analytics.service';
import {Analytics} from '../../../name.annotation';
import {CoursesService} from '../../../courses.service';
import {ProgressService} from '../../../progress.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {ResourcesService} from '../../../course/services/resources.service';
import {Resource} from '../../../domain/media';
import {ManeuversService} from '../../../course/services/maneuvers.service';
import {AuthService} from '../../../services/auth.service';
import {AuthContextService} from '../../../services/auth-context.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-resource',
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.scss']
})
@Analytics('resource')
export class ResourceComponent implements OnInit, OnDestroy {
  resource: Resource;
  initialized = false;
  course: any;
  user: any;
  loaded = false;
  routeDataSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private authContextService: AuthContextService,
    private analyticsService: AnalyticsService
  ) {
  }

  ngOnDestroy(): void {
    this.routeDataSub?.unsubscribe();
  }

  ngOnInit() {
    console.log('ResourceComponent:ngOnInit');

    this.routeDataSub = this.route.data.subscribe((data) => {
      this.resource = data?.resource;
      this.course = data?.course;
    });

    this.authService.renew().then(
      (value) => {
        this.user = this.authContextService.user;
        this.loaded = true;
      },
      (reason) => (this.loaded = true)
    );

    this.authContextService.onRenew().subscribe((value) => {
      this.user = this.authContextService.user;
      this.loaded = true;
    });

    if (!this.initialized) {
      if (this.course) {
        this.analyticsService.documentCourseViewed(
          this.course,
          this.resource.media.pspdfkitId
        );
      } else {
        this.analyticsService.documentViewed(this.resource.media.pspdfkitId);
      }
      this.initialized = true;
    }
  }

  enableDownloadAndPrint() {
    return this.course
      //&& ['CFI_I', 'CFI_AI', 'CFI_FOI'].indexOf(this.course.webAppId) < 0
      && ['FM_CFI_6_PD', 'CFI_STUDY_GUIDE', 'CFII_STUDY_GUIDE'].indexOf(this.resource.media.pspdfkitId) < 0;
  }
}
